import { AxiosInstance } from 'axios'
import { InvitationSearchResult } from '@dc-shared-web/hooks/api/invitation'

export type GetInvitationsQueryParams = {
  page?: number
  limit?: number
  sortField?: string
  name?: string
  email?: string
  teamUUID?: string
}

export const fetchSearchInvitationsResult = async (
  apiClient: AxiosInstance,
  params?: GetInvitationsQueryParams
): Promise<InvitationSearchResult> => {
  const { data } = await apiClient.get(`/api/invites`, { params })

  return data
}
